import React, { useState, useEffect, Dispatch, SetStateAction } from 'react'

import { Button, RadioButton } from '@components/atoms'
import { RadioGroup } from '@headlessui/react'
import { QuestionType } from '@models/questions.model'
import { modalCreators } from '@store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@store/hooks'

import { ContainerTitle, ContainerDesc } from '../styles'
import { questionStyles } from './styles'

const {
	container,
	containerQuestion,
	numberContainer,
	radioGroup,
	containerButton,
} = questionStyles

interface QuestionProps {
	value: QuestionType
	index?: string | number
	setValue?: Dispatch<SetStateAction<Array<QuestionType>>> | undefined
}

export const QuestionSimulateExam = ({
	value,
	index,
	setValue,
	...props
}: QuestionProps) => {
	const [answer, setAnswer] = useState()
	const [questionAnswered, setQuestionAnswered] = useState<boolean>(false)

	const dispatch = useAppDispatch()
	const { fontSize } = useAppSelector((state) => state.fonts)

	const handleAnswerResponse = () => {
		if (answer === undefined) {
			dispatch(
				modalCreators.openAlert({
					type: 'error',
					title: 'Ocorreu um erro',
					buttonLabel: 'Fechar',
					description: 'Uma resposta é obrigatória.',
				})
			)
		} else {
			setQuestionAnswered(true)
		}
	}

	useEffect(() => {
		if (questionAnswered) {
			if (setValue) {
				setValue((prev) => {
					const newdArray = prev.map((item) =>
						item.id === value.id
							? {
									...item,
									answer,
									questionAnswered: true,
							  }
							: item
					)

					return newdArray
				})
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [questionAnswered])

	return (
		<>
			<div className={container()}>
				<div className={containerQuestion()} {...props}>
					<ContainerTitle>
						<div className={numberContainer()}>{index}</div>
						<ContainerDesc fontSize={fontSize}>
							<h6>{value?.title}</h6>
						</ContainerDesc>
					</ContainerTitle>
					<ContainerDesc fontSize={fontSize}>
						<p dangerouslySetInnerHTML={{ __html: value?.description || '' }} />
					</ContainerDesc>
				</div>

				<RadioGroup
					value={answer}
					onChange={setAnswer}
					className={radioGroup()}
					disabled={questionAnswered}
				>
					<RadioGroup.Option value>
						{({ checked }) => (
							<RadioButton
								questionType
								checked={checked}
								questionAnswer={questionAnswered}
							/>
						)}
					</RadioGroup.Option>
					<RadioGroup.Option value={false}>
						{({ checked }) => (
							<RadioButton
								questionType={false}
								checked={checked}
								questionAnswer={questionAnswered}
							/>
						)}
					</RadioGroup.Option>
				</RadioGroup>

				<div className={containerButton()}>
					<Button
						css={{ maxWidth: '329px' }}
						onClick={handleAnswerResponse}
						disabled={questionAnswered}
					>
						Responder
					</Button>
				</div>
			</div>
		</>
	)
}
